<template>
    <app-wrapper>
        <app-header
            :page="'Profile'"
            medium-max-width="max-w-1000"
            medium-max-width-inner="max-w-500">

            <template #navigation />

            <template #top>
                <div class="flex items-center">
                    <div class="flex-initial p-4">
                        <svg class="w-17" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="35" cy="35" r="34.5" fill="#F4F7FD" stroke="#DBE3EE"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M47.0927 41.5011C45.0852 38.8165 42.4961 37.4281 38.121 36.9821C37.3314 36.8195 36.7362 36.1036 36.7362 35.2534C36.7362 34.6309 38.6881 32.7672 38.6742 32.7534C40.6889 30.6215 41.769 27.1574 41.769 24.4942C41.769 20.3577 38.5151 17 34.4999 17C30.4847 17 27.2307 20.3577 27.2307 24.4942C27.2307 27.1719 28.2831 30.6568 30.3185 32.7888C30.3185 32.7888 32.2638 34.631 32.2638 35.2535C32.2638 36.1534 31.5993 36.9038 30.7407 37.0105C26.4552 37.4709 23.894 38.8517 21.9069 41.5012C21.3323 42.2661 21.0206 43.8032 21 44.6252C21.0069 44.8376 21 48.1668 21 48.1668C21 49.7322 22.2393 51 23.7693 51H45.2305C46.7605 51 48 49.7322 48 48.1668C48 48.1668 47.9932 44.8376 48 44.6252C47.9795 43.8031 47.6671 42.266 47.0927 41.5011Z" fill="#C9D6F0"/>
                        </svg>
                    </div>
                    <div class="flex-auto">
                        <h4 class="mb-1.5 leading-tight">{{ $root.user.full_name }}</h4>
                        <p>{{ $root.user.email }}</p>
                    </div>
                </div>
            </template>

        </app-header>
        <app-body medium-max-width="max-w-500" footer short>

            <template #main>
                <div class="flex flex-col space-y-4 mt-4">
                    <transition
                        enter-active-class="ease-out duration-300"
                        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                        leave-active-class="ease-in duration-200"
                        leave-class="opacity-100 translate-y-0 sm:scale-100"
                        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                        <div 
                            v-show="sameBankAccountError" 
                            class="fixed inset-0 flex items-center justify-center z-50"
                            role="dialog" 
                            aria-modal="true" 
                            aria-labelledby="modal-headline"
                        >
                            <!-- Background overlay -->
                            <div class="absolute inset-0 opacity-50" style="background-color: black;"></div>

                            <!-- Modal content -->
                            <div class="relative mx-2 bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6">
                            <div>
                                <div>
                                <div class="mt-2">
                                    <p class="leading-5 text-red-500 text-center">
                                    Your paystub shows your most recent income in account ending {{ loanMask }}, which does not match this selected account. If we are unable to verify your income in your selected account, your loan will be denied.
                                    </p>
                                </div>
                                </div>
                            </div>
                            <div class="mt-5 flex">
                                <span class="flex w-full rounded-md pr-1">
                                <button 
                                    id="cancel-confirm" 
                                    @click="sameBankAccountError = false" 
                                    type="button" 
                                    class="inline-flex justify-center font-bold w-full items-center rounded-md border border-danger px-4 py-2 text-primary leading-6 font-medium shadow-sm focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition ease-in-out duration-150 sm:text-sm sm:leading-5 mr-2"
                                >
                                    Cancel
                                </button>
                                <button 
                                    id="confirm-confirm" 
                                    @click="confirmBankAccountErrorSave" 
                                    type="button" 
                                    class="inline-flex justify-center font-bold w-full rounded-md border border-primary px-4 py-2 bg-white text-primary leading-6 font-medium shadow-sm focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition ease-in-out duration-150 sm:text-sm sm:leading-5 ml-2"
                                >
                                    I understand, Please continue
                                </button>
                                </span>
                            </div>
                            </div>
                        </div>
                    </transition>

                    <!-- ERROR MESSAGE BLOCK -->
                    <transition
                        enter-active-class="ease-out duration-300"
                        enter-class="opacity-0"
                        enter-to-class="opacity-100"
                        leave-active-class="ease-in duration-200"
                        leave-class="opacity-100"
                        leave-to-class="opacity-0"
                    >
                        <div v-if="errorOccurred" class="fixed inset-0 mt-0 flex items-center justify-center z-50">
                            <!-- Background overlay -->
                            <div class="absolute inset-0 bg-black opacity-50"></div>
                            
                            <!-- Modal content -->
                            <div class="relative mx-4 bg-white rounded-lg shadow-xl transform transition-all sm:max-w-lg sm:w-full">
                                <div class="px-4 pt-5 pb-4 sm:p-6">
                                    <div class="sm:flex sm:items-start">
                                        <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                            <svg class="h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                            </svg>
                                        </div>
                                        <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                            <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                                                Warning!
                                            </h3>
                                            <div class="mt-2">
                                                <p class="text-grey-500 text-sm">
                                                    {{ errorMessage }}
                                                </p>
                                                <p class="text-primary-500 text-sm mt-2">
                                                    Please contact support to update your information <a :href="'mailto:' + supportEmail">
                                                        {{ supportEmail }}
                                                    </a>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                        <button @click="errorOccurred = false" type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm">
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>
                    <!-- ERROR MESSAGE BLOCK END -->

                    <!-- PAYSTUB VERIFICATION RESUMED BLOCK -->
                    <transition
                        enter-active-class="ease-out duration-300"
                        enter-class="opacity-0"
                        enter-to-class="opacity-100"
                        leave-active-class="ease-in duration-200"
                        leave-class="opacity-100"
                        leave-to-class="opacity-0"
                    >
                        <div v-if="paystubVerificationResumed" data-testid="paystub-verification-resumed" class="fixed inset-0 mt-0 flex items-center justify-center z-50">
                            <!-- Background overlay -->
                            <div class="absolute inset-0 bg-black opacity-50"></div>

                            <!-- Modal content -->
                            <div class="relative mx-4 bg-white rounded-lg shadow-xl transform transition-all sm:max-w-lg sm:w-full">
                                <div class="px-4 pt-5 pb-4 sm:p-6">
                                    <div class="sm:flex sm:items-start">
                                        <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10">
                                            <svg class="h-6 w-6 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                                            </svg>
                                        </div>
                                        <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                            <h3 class="text-lg leading-6 font-medium text-gray-900">
                                                Income account updated
                                            </h3>
                                            <div class="mt-2">
                                                <p class="text-grey-500 text-sm">
                                                    We found your paystub deposit in the selected account. Income verification has resumed automatically — no further action is needed.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                        <button @click="continueAfterVerificationResumed" type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm">
                                            Continue
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>
                    <!-- PAYSTUB VERIFICATION RESUMED BLOCK END -->

                  
                    <div class="border rounded-lg bg-gray-50 border-gray-200">
                        <div class="flex justify-between items-center bottom-line p-4">
                            <h6 v-if="! editingAccount" class="text-base font-semibold">Account Information</h6>
                            <h6 v-else @click.prevent="() => { copyAccountProperties(); editingAccount = false }" class="cursor-pointer text-base font-semibold">Cancel</h6>

                            <a v-if="! editingAccount" @click.prevent="editingAccount = true" class="cursor-pointer font-semibold no-underline text-sm">Edit</a>
                            <a v-else @click.prevent="saveAccount" class="cursor-pointer font-semibold no-underline text-sm">
                                <template v-if="! editingAccountLoading">
                                    Save Changes
                                </template>
                                <template v-else>
                                    <i class="fa fa-circle-notch fa-spin" />
                                </template>
                            </a>
                        </div>
                        <account-list v-if="! editingAccount" />
                        <account-form v-else
                                      :errors="editingAccountErrors"
                                      :first_name.sync="editingAccountForm.first_name"
                                      :middle_name.sync="editingAccountForm.middle_name"
                                      :last_name.sync="editingAccountForm.last_name"
                                      :email.sync="editingAccountForm.email"
                                      :password.sync="editingAccountForm.password"
                                      :password_confirmation.sync="editingAccountForm.password_confirmation"
                                      :can-change-email="false"
                        />
                    </div>

                    <!--  BILLING BANK ACCOUNT BLOCK START   -->
                    <div class="rounded-lg bg-gray-50"
                         :class="{
                            'border border-gray-200': ! billingErrorStatus,
                            'border-2 border-danger': billingErrorStatus
                        }">
                        <div class="flex justify-between items-center p-4">
                            <h6 v-if="! editingBilling" class="cursor-pointer text-base font-semibold">Billing</h6>
                            <h6 v-else @click.prevent="editingBilling = false" class="cursor-pointer text-base font-semibold">Cancel</h6>

                            <template v-if="! billingErrorStatus">
                                <a v-if="! editingBilling" @click.prevent="editingBilling = true" class="cursor-pointer font-semibold no-underline text-sm">
                                    Change
                                </a>
                                <a v-else data-testid="billing-save" @click.prevent="saveBilling(false)" class="cursor-pointer font-semibold no-underline text-sm">
                                    <template v-if="! editingBillingLoading">
                                        Save Changes
                                    </template>
                                    <template v-else>
                                        <i class="fa fa-circle-notch fa-spin" />
                                    </template>
                                </a>
                            </template>
                            <template v-else>
                                <a v-if="! editingBilling" @click.prevent="editingBilling = true" class="cursor-pointer font-semibold no-underline text-sm">
                                    Fix now
                                </a>
                                <a v-else data-testid="billing-save" @click.prevent="saveBilling(false)" class="cursor-pointer font-semibold no-underline text-sm">
                                    <template v-if="! editingBillingLoading">
                                        Save Changes
                                    </template>
                                    <template v-else>
                                        <i class="fa fa-circle-notch fa-spin" />
                                    </template>
                                </a>
                            </template>
                        </div>
                        <div v-if="warningNoIncome">
                            <p class="p-4 text-red-500">
                                We are unable to verify your income in this account. 
                                Please contact <a :href="'mailto:' + supportEmail">{{ supportEmail }}</a> if you would still like to change your account.
                            </p>
                        </div>

                        <billing-list v-if="! editingBilling"
                                      data-testid="billing-account-summary"
                                      :account="account"
                                      :billing-error="billingErrorStatus"
                                      @update-user="$emit('updateUser', $event.target.value)"
                        />
                        
                        <billing-form v-else
                                      :errors="editingBillingErrors"
                                      :selected.sync="editingBillingAccount"
                                      :change-bank="changeBank"
                                      @hideChangeBankMsg="hideChangeBankMsg"
                                      @clearErrors="clearBillingErrors"
                        />
                    </div>
                    <!--  BILLING BANK ACCOUNT BLOCK END   -->
                    <div class="border rounded-lg bg-gray-50 border-gray-200">
                        <div class="flex items-center bottom-line p-4">
                            <h6 class="text-base font-semibold">Security</h6>
                        </div>
                        <div class="p-4">
                            <div class="flex justify-between items-center">
                                <p>
                                    Two Factor Authentication
                                </p>
                                <p v-if="$root.user.two_factor_secret === null" class="font-semibold">Disabled</p>
                                <p v-else class="font-semibold">Enabled</p>
                            </div>
                            <div v-if="$root.user.two_factor_secret !== null" class="py-4 flex justify-between items-center">
                                <p>
                                    Phone
                                </p>
                                <p class="font-semibold">{{ $root.user.phone_number | phone }}</p>
                            </div>
                            <form v-if="$root.user.two_factor_secret === null" action="/user/two-factor-authentication" method="POST">
                                <input type="hidden" name="_token" :value="csrf" />
                                <button type="submit" class="mt-4 block w-full no-underline border border-primary-700 rounded text-primary-700 text-center text-base font-semibold py-3">
                                    Setup
                                </button>
                            </form>
                            <form v-else action="/user/two-factor-authentication" method="POST">
                                <input type="hidden" name="_token" :value="csrf" />
                                <input type="hidden" name="_method" value="DELETE" />
                                <button type="submit" class="mt-4 block w-full no-underline border border-primary-700 rounded text-primary-700 text-center text-base font-semibold py-3">
                                    Disable
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </template>

        </app-body>
    </app-wrapper>
</template>

<script>
    import AccountList from './account/AccountList';
    import AccountForm from './account/AccountForm';
    import BillingList from './account/BillingList';
    import BillingForm from './account/BillingForm';

    export default {
        mixins: [
            require('../mixins/InteractsWithGtag').default,
            require('../mixins/InteractsWithLoans').default
        ],

        props: ['csrf'],

        components: {
            AccountForm,
            AccountList,
            BillingList,
            BillingForm
        },

        computed: {
            accounts() {
                return this.$root.user.banking_accounts;
            },

            /**
             * @return {Object|null}
             */
            account() {
                return this.$root.user.loans[0].banking_account;
            }
        },

        data() {
            return {
                gTagPageName: 'account',

                billingErrorStatus: false,

                editingAccount: false,
                editingAccountLoading: false,
                editingAccountErrors: [],
                editingAccountForm: {
                    first_name: '',
                    middle_name: '',
                    last_name: '',
                    email: '',
                    password: null,
                    password_confirmation: null
                },

                editingBilling: false,
                paystabMask: null,
                loanMask: null,
                changeBank: false,
                sameBankAccountError: false,
                editingBillingLoading: false,
                editingBillingErrors: [],
                editingBillingAccount: null,
                warningNoIncome: false,
                supportEmail: window.support_email,
                errorOccurred: false,
                errorMessage: null,
                paystubVerificationResumed: false,
                paystubVerificationLoanId: null
            }
        },

        created() {
            this.copyAccountProperties();
            this.copyBillingProperties();
        },

        mounted() {
            let urlParams = new URLSearchParams(window.location.search);

            if (urlParams.get('main-error')) {
                this.errorOccurred = true;
                this.errorMessage = urlParams.get('main-error');
                let currentUrl = new URL(window.location.href);
                currentUrl.search = '';
                window.history.pushState({}, document.title, currentUrl);
            }            

            this.originalBankingAccountId = this.$root.user.loans[0].banking_account_id;

            this.editingBilling = urlParams.has('edit-billing');
            
            this.changeBank = urlParams.has('change-bank');
        },

        methods: {
            // The resolved loan is back in the signup pipeline (paystubs_processing), so the
            // natural next screen is its onboarding page — not the billing form the borrower
            // just finished with.
            continueAfterVerificationResumed() {
                if (this.paystubVerificationLoanId) {
                    window.location.href = '/signup/welcome/' + this.paystubVerificationLoanId;
                    return;
                }

                this.paystubVerificationResumed = false;
            },

            getPaystubMaskNumber(account){
                this.$http.get(`/account/get-paystub-mask`).then(({ data }) => {                    
                    this.paystabMask = data?.mask;
                    this.loanMask = data?.mask;
                });
            },
            hideChangeBankMsg() {
                this.changeBank = false;
            },
            confirmBankAccountErrorSave() {                
                this.sameBankAccountError = false;
                this.saveBilling(true)
            },
            clearBillingErrors() {
                this.editingBillingErrors = [];
            },
            /**
             * @returns {void}
             */
            copyAccountProperties() {
                this.editingAccountForm.first_name = this.$root.user.first_name;
                this.editingAccountForm.middle_name = this.$root.user.middle_name;
                this.editingAccountForm.last_name = this.$root.user.last_name;
                this.editingAccountForm.email = this.$root.user.email;
            },

            /**
             * @returns {void}
             */
            copyBillingProperties() {
                this.editingBillingAccount = _.cloneDeep(this.account);
            },

            /**
             * @returns {void}
             */
            saveAccount() {
                this.editingAccountLoading = true;

                this.$http.post(`/account/account`, this.editingAccountForm).then(({ data }) => {
                    this.editingAccountErrors = [];
                    this.$root.$emit('updateUser', data);

                    this.editingAccount = false;
                }, error => {
                    this.errorOccurred = true;
                    this.errorMessage = error.response.data.message;
                    this.editingAccountErrors = error.hasOwnProperty('response') ? error.response.data.errors : error;
                }).finally(() => {
                    setTimeout(() => {
                        this.editingAccountLoading = false;
                    }, 250);
                });
            },

            /**
             * @returns {void}
             */
            saveBilling(force = false) {
                this.warningNoIncome = false;
                this.editingBillingLoading = true;
                
                this.$http.post(`/account/billing`, {
                    banking_account_id: this.editingBillingAccount.id,
                    force: force
                }).then(({ data }) => {
                    this.editingBillingErrors = [];
                    this.$root.$emit('updateUser', data);
                    
                    if (this.originalBankingAccountId !== this.editingBillingAccount.id) {
                        this.originalBankingAccountId = this.editingBillingAccount.id;
                        this.$root.$emit('action', 'changed-billing-account');
                    }

                    this.paystubVerificationResumed = data.paystub_verification_resumed === true;
                    this.paystubVerificationLoanId = data.paystub_verification_loan_id || null;
                    this.editingBilling = false;
                    // Clear the loan mask on sucessful save
                    localStorage.removeItem('unverified_income');
                }, error => {
                    this.errorOccurred = true;
                    this.errorMessage = error.response.data.message;
                }).finally(() => {
                    this.editingBillingLoading = false;
                });
            }
        },
        watch: {
            sameBankAccountError(newVal) {
                if (newVal) {
                    document.body.classList.add('overflow-hidden');
                } else {
                    document.body.classList.remove('overflow-hidden');
                }
            },
            editingBillingAccount() {                
                this.getPaystubMaskNumber();
            },
            account: {
              immediate: true,
              handler: function(account, oldAccount) {
                this.billingErrorStatus = account === null;
              }
            }
        },
    }
</script>
